import { iUser } from "../interfaces/iUser";
import { Get } from "../utilities/apiCall";

export async function SearchForUsers(username: string): Promise<iUser[]> {
    const result: iUser[] = (await Get("Users/Search?query=" + username)).users;
    return result;
}
